import GoogleTagManagerHelper from '@tracking/gtm-helper';
import { competitionUrl } from '@utilities/WindowContext';

export const trackVirtPath = async (id: any, type: string) => {
  const trackedType = type.replace(/vod/i, 'video').toLowerCase();
  const path = `/${competitionUrl}/uefatv/${trackedType}/${id}/`;
  await GoogleTagManagerHelper.addVirtualPage({
    virtPath: path,
    pageName: path,
    pageType: trackedType,
    contentSection3: trackedType,
  });
};
